import { useMemo } from "react";

import { formatProvider } from "@stacklet/ui";
import { useSearchParams } from "react-router";

import { useProvider } from "app/contexts/ProviderContext";
import { type FilterBooleanOperator } from "app/views/admin/policy-collections/__generated__/PolicyCollectionsRefetchQuery.graphql";

export function usePolicyCollectionFilterElement() {
  const [searchParams] = useSearchParams({});
  const search = searchParams.get("search");

  const selectedProvider = useProvider();

  return useMemo(() => {
    const searchFilter = {
      single: {
        name: "name",
        operator: "contains",
        value: search,
      },
    };
    const providerFilter = {
      single: { name: "provider", value: formatProvider(selectedProvider) },
    };

    if (search) {
      return {
        multiple: {
          operands: [searchFilter, providerFilter],
          operator: "AND" as FilterBooleanOperator,
        },
      };
    }
    return providerFilter;
  }, [search, selectedProvider]);
}
